import styled from '@emotion/styled';
import { Select, Spin } from 'antd';
import DownSvg from 'assets/svg/Down';
import NegativeTriangle from 'assets/svg/NegativeTriangle';
import PositiveTriangle from 'assets/svg/PositiveTriangle';
import { colorConstants } from 'config/colorConstants';
import React from 'react';
import tw from 'twin.macro';

export const CustomSelect = styled(Select)`
    ${tw`border border-purpleFont rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
    .ant-select-selection-item {
        height: 30px;
    }
`;

interface UpLiftRoiDataType {
    label: string;
    value: number | string;
    mainText: string;
    roi: number;
    uplift: number;
    originalROI: number;
    originalUPlift: number;
}

//dummy data
// const dummySelectData = [
//     {
//         label: 'name12222',
//         value: 12,
//         mainText: 'asd name',
//         roi: null,
//         uplift: null,
//     },
//     {
//         label: 'name1',
//         value: 121,
//         mainText: 'asd namedd',
//         roi: {
//             value: 12,
//             isPositive: false,
//         },
//         uplift: {
//             value: 12,
//             isPositive: true,
//         },
//     },
//     {
//         label: 'namedd',
//         value: 122,
//         mainText: 'asd nameasd',
//         roi: {
//             value: 12,
//             isPositive: true,
//         },
//         uplift: {
//             value: 12,
//             isPositive: true,
//         },
//     },
// ];

const { Option } = Select;
const UpliftRoiDropdown = ({
    data,
    style,
    onChange,
    value,
    originalROI,
    originalUPlift,
    disabled,
    loading,
    onClick,
}: {
    data: UpLiftRoiDataType[];
    style?: React.CSSProperties;
    onChange: Function;
    value: any;
    originalROI: number;
    originalUPlift: number;
    disabled: boolean;
    loading: boolean;
    onClick: Function;
}) => {
    return (
        <div>
            <CustomSelect
                onChange={(val: any, item: any) => onChange(val, item)}
                style={{ ...style }}
                value={value}
                suffixIcon={<DownSvg />}
                className=" dropdown-width uniqSelROIUpLiftDropdown"
                onClick={() => onClick()}
            >
                {loading ? (
                    <Option>
                        <div className="flex justify-center items-center p-4">
                            <Spin />
                        </div>
                    </Option>
                ) : (
                    data.map((item, index) => {
                        const isUpliftPositive = item.uplift > originalUPlift;
                        const isRoiPositive = item.roi > originalROI;
                        return (
                            <Option item={item} value={item?.value} key={index}>
                                <div>
                                    <div className="text-fontGray font-medium font-xxs mt-1">{item.label}</div>
                                    <div className="flex gap-2">
                                        {item?.uplift && (
                                            <p className="flex gap-1 items-center">
                                                <span className="text-fontGreyAlt font-xxs">Uplift:</span>
                                                <span>
                                                    {isUpliftPositive ? <PositiveTriangle /> : <NegativeTriangle />}
                                                </span>
                                                <span
                                                    style={{
                                                        color: isUpliftPositive
                                                            ? colorConstants.limeGreen
                                                            : colorConstants.red,
                                                    }}
                                                >
                                                    {item.uplift.toFixed(2)}
                                                </span>
                                            </p>
                                        )}
                                        {item?.roi && (
                                            <p className="flex gap-1 items-center">
                                                <span className="text-fontGreyAlt font-xxs">ROI:</span>
                                                <span>
                                                    {isRoiPositive ? <PositiveTriangle /> : <NegativeTriangle />}{' '}
                                                </span>
                                                <span
                                                    style={{
                                                        color: isRoiPositive
                                                            ? colorConstants.limeGreen
                                                            : colorConstants.red,
                                                    }}
                                                >
                                                    {item.roi.toFixed(2)}
                                                </span>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </Option>
                        );
                    })
                )}
            </CustomSelect>
        </div>
    );
};

export default UpliftRoiDropdown;
